// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1-uPM","footer":"ModalError_footer__jMMxz"};